import { render, staticRenderFns } from "./ModelsAll.vue?vue&type=template&id=5f141c22&scoped=true&"
import script from "./ModelsAll.vue?vue&type=script&lang=js&"
export * from "./ModelsAll.vue?vue&type=script&lang=js&"
import style0 from "./ModelsAll.vue?vue&type=style&index=0&id=5f141c22&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f141c22",
  null
  
)

export default component.exports